<template>
  <div class="physioPowerList" v-loading="loading">
    <div class="filter">
      <el-form ref="form" class="filter_form" :model="form" label-width="70px">
        <el-form-item class="filter_form_item" label="医生姓名">
          <el-input v-model="form.name" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <div class="form_btnList">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
        </div>
      </el-form>
    </div>
    <div class="table">
      <el-table
        :data="list">
        <el-table-column type="index" :index="tableIndexMethod" label="序号" width="50"></el-table-column>
        <el-table-column label="医生姓名" prop="doctorName" min-width="210"></el-table-column>
        <el-table-column label="可执行项目" prop="doctorRelevances" min-width="280" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="['', null, undefined].includes(scope.row.doctorRelevances)" class="table_not_configured">未配置（可能影响执行项目）</span>
            <span v-else>{{ scope.row.doctorRelevances.map(v => { return v.secondCategory.physioLabel }).join('、') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="小程序预约项目" prop="appletConfigs" min-width="280" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="['', null, undefined].includes(scope.row.appletConfigs)" class="table_not_configured">未配置</span>
            <span v-else>{{ scope.row.appletConfigs.map(v => { return v.physioKindName }).join('、') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="项目执行人" prop="executeType" min-width="140">
          <template slot-scope="scope">
            {{ scope.row.executeType | executeTypeFilter }}
          </template>
        </el-table-column>
        <el-table-column label="操作员" prop="updateBy" min-width="140"></el-table-column>
        <el-table-column label="创建时间" prop="createTime" min-width="180">
          <template slot-scope="scope">
            {{ scope.row.createTime ? new Date(scope.row.createTime).Format('yyyy-MM-dd hh:mm:ss') : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="更新时间" prop="updateTime" min-width="180">
          <template slot-scope="scope">
            {{ scope.row.updateTime ? new Date(scope.row.updateTime).Format('yyyy-MM-dd hh:mm:ss') : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" @click="toEdit(scope.row.doctorId)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        :current-page="pageNo"
        :page-size="pageSize"
        background
        layout="total, prev, pager, next"
        :total="total"
        @current-change="pageNoChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import { getPhysioPowerList } from '@/api/physio.js'

  export default {
    name: 'physioPowerList',
    data () {
      return {
        loading: false,
        form: {
          name: ''
        },
        pageNo: 1,
        pageSize: 10,
        list: [],
        total: 0
      }
    },
    filters: {
      executeTypeFilter (value) {
        const map = {
          1: '本人执行',
          2: '指定医生',
          3: '不指定',
          4: '指定公共外治'
        }
        return map[value]
      }
    },
    created () {
      this.getList()
    },
    methods: {
      tableIndexMethod (index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
      async getList () {
        this.loading = true
        const res = await getPhysioPowerList({
          ...this.form,
          deptId: sessionStorage.getItem('deptId'),
          pageNum: this.pageNo,
          pageSize: this.pageSize
        })
        this.loading = false
        if (res.code === 200) {
          this.list = res.rows
          this.total = res.total
        }
      },
      pageNoChange (num) {
        this.pageNo = num
        this.getList()
      },
      search () {
        this.pageNo = 1
        this.getList()
      },
      reset () {
        this.form.name = ''
        this.pageNo = 1
        this.getList()
      },
      toEdit (id) {
        this.$router.push(`/backstage/physioPowerEdit/${id}`)
      }
    }
  }
</script>

<style lang="less" scoped>
  .physioPowerList {
    box-sizing: border-box;
    padding: 20px;
    width: 100%;
    height: 100%;
    background-color: #FFFFFF;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .filter {
    width: 100%;
  }

  .filter_form {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: -20px;
    width: 100%;
    overflow: hidden;
  }

  .filter_form /deep/ .el-form-item__label {
    line-height: 32px;
    color: #1F2329;
  }

  .filter_form /deep/ .el-form-item__content {
    line-height: 32px;
  }

  .filter_form_item {
    margin: 20px 12px 0 0;
    width: 250px;
  }

  .form_btnList {
    margin: 20px 0 0 0;
  }

  .table {
    margin: 20px 0 0 0;
    width: 100%;
  }

  .table_not_configured {
    color: #999999;
  }

  .pagination {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 20px 0 0 0;
    width: 100%;
  }
</style>